var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"translate",rawName:"v-translate"}],class:_vm.$style.container,attrs:{"href":_vm.signUpUrl}},[_vm._v("register")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e2aefb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","vector":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterButton.vue
// module id = xgOI
// module chunks = 0